import { HeroPortrait } from "@/components/masterclass/HeroPortrait";

type Props = {
  src: string;
  alt: string;
  avifSrcSet?: string;
  webpSrcSet?: string;
  jpgSrcSet?: string;
  sizes?: string;
  fallbackSrc?: string;
  placeholderSrc?: string;
  priority?: boolean;
  /**
   * Optional per-instance overrides. When omitted, the About portrait
   * reads the site-wide `--about-anchor-x` / `--about-anchor-y`
   * variables defined in `src/index.css` (tune them there — or live
   * from `/qa/about` — without editing this component).
   */
  anchorX?: string;
  anchorY?: string;
  /** Responsive crop zoom; defaults to the About-specific presets. */
  zoom?: string;
  /** Label shown in the QA crop debug overlay. */
  debugLabel?: string;
};

/**
 * About-page portrait. Thin wrapper around <HeroPortrait> that swaps
 * the crop anchor from the hero variables to a dedicated About set
 * (`--about-anchor-x/y`, with mobile / tablet / desktop presets).
 * This keeps the hero and about crops independently tunable.
 */
export const AboutPortrait = ({
  anchorX,
  anchorY,
  zoom,
  ...rest
}: Props) => (
  <HeroPortrait
    {...rest}
    anchorX={anchorX ?? "var(--about-anchor-x, 50%)"}
    anchorY={anchorY ?? "var(--about-anchor-y, 32%)"}
    zoom={zoom ?? "var(--about-zoom, 1)"}
    debugLabel={rest.debugLabel ?? "about"}
  />
);
